import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'wsm-common-data';
import FacetCount from './FacetCount';
import ColorSwatch from './ColorSwatch';

const Facet = ({
	facetLabel,
	inputType,
	facetValue,
	facetCount,
	groupId,
	isDisabled,
	onChange,
	handleSelect
}) => {
	const { showFacetCounts } = usePrefs();

	const getSwatchColor = (group, value) => {
		if (value === 'ALL') return null;
		if (
			group === 'normalExteriorColor' ||
			(group === 'normalInteriorColor' && value)
		) {
			return value;
		}
		return null;
	};
	const swatchColor = getSwatchColor(groupId, facetValue);

	return (
		<li className={`${inputType} mb-lg-4`} key={`${groupId}-${facetValue}`}>
			<label
				className={isDisabled ? 'disabled' : null}
				htmlFor={`${groupId}-${facetValue}`}
			>
				<input
					type={inputType}
					name={groupId}
					value={facetValue}
					id={`${groupId}-${facetValue}`}
					onChange={(e) => onChange(e, groupId)}
					checked={handleSelect(facetValue)}
					disabled={isDisabled}
				/>
				<span className="facet-list-facet-label-text-container">
					{swatchColor && <ColorSwatch color={swatchColor} />}
					<span className="facet-list-facet-label-text">
						{facetLabel}
						{showFacetCounts === 'true' && facetCount && (
							<FacetCount count={facetCount} />
						)}
					</span>
				</span>
			</label>
		</li>
	);
};

Facet.propTypes = {
	inputType: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	isDisabled: PropTypes.bool.isRequired,
	facetLabel: PropTypes.string.isRequired,
	facetValue: PropTypes.string.isRequired,
	groupId: PropTypes.string.isRequired,
	facetCount: PropTypes.number,
	handleSelect: PropTypes.func.isRequired
};

Facet.defaultProps = {
	facetCount: undefined
};

export default Facet;
